export const en = {
    'all-audience': 'Entire audience',
    'by-selected-region': 'In the selected region',
    metrikaAudience: 'Yandex.Audience and Yandex.Metrica',
    'users-profiles': 'User profile'
};
